import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

const GAMES = [
  {
    id: 'slot',
    name: 'Slot Machine',
    icon: '🎰',
    desc: 'Pörgesd meg a tekercseket és nyerd a jackpotot!',
    available: true,
    route: '/slot',
    tag: 'Játssz most',
  },
  {
    id: 'blackjack',
    name: 'Blackjack',
    icon: '🃏',
    desc: 'Multiplayer asztal – verje meg a dealert 21-gyel!',
    available: true,
    route: '/blackjack',
    tag: 'Játssz most',
  },
  {
    id: 'roulette',
    name: 'Rulett',
    icon: '🎡',
    desc: 'Fogadj, pörgesd a kereket, és várd az eredményt!',
    available: true,
    route: '/roulette',
    tag: 'Játssz most',
  },
];

export default function Lobby() {
  const { user, updateBalance } = useAuth();
  const navigate = useNavigate();
  const [balance, setBalance] = useState(user?.balance ?? 0);

  useEffect(() => {
    api.get('/wallet/balance').then((res) => {
      setBalance(res.data.balance);
      updateBalance(res.data.balance);
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      <main className="max-w-5xl mx-auto px-4 py-10">
        {/* Üdvözlő */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold">
            Üdv, <span className="text-yellow-400">{user?.username}</span>! 👋
          </h1>
          <p className="text-slate-400 mt-1">Válassz játékot és próbálj szerencsét.</p>
        </div>

        {/* Egyenleg kártya */}
        <div className="card mb-8 flex items-center justify-between">
          <div>
            <p className="text-slate-400 text-sm">Aktuális egyenleg</p>
            <p className="text-4xl font-bold text-yellow-400 mt-1">{Number(balance).toLocaleString('hu')} 💰</p>
          </div>
          <div className="text-6xl opacity-20">💰</div>
        </div>

        {/* Játékok */}
        <h2 className="text-lg font-semibold mb-4 text-slate-300">Játékok</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {GAMES.map((game) => (
            <div
              key={game.id}
              onClick={() => game.available && navigate(game.route)}
              className={`card flex flex-col items-center text-center gap-3 relative overflow-hidden transition-all ${
                game.available
                  ? 'cursor-pointer hover:border-yellow-500/50 hover:bg-slate-700'
                  : 'cursor-not-allowed opacity-60'
              }`}
            >
              <div className="text-5xl">{game.icon}</div>
              <div>
                <h3 className="font-semibold text-lg">{game.name}</h3>
                <p className="text-slate-400 text-sm mt-1">{game.desc}</p>
              </div>
              <span className={`badge mt-auto ${game.available ? 'badge-green' : 'bg-slate-600 text-slate-300'}`}>
                {game.tag}
              </span>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
